export function pageToLayout({
  page,
  pageItemObjects,
  name,
  includeMirroredVersion = false,
}) {
  let wells = 0;

  let pageItems = null;
  if (Array.isArray(page.pageItems)) {
    pageItems = page.pageItems.map((id) => {
      let item = pageItemObjects.get(id).toJS();
      // delete stuff we don't care about
      // delete item.id;
      delete item.spellCheck;
      delete item.imageID;
      delete item.svg;

      item.text = '';
      item.styles = [];

      if (item.itemType === 'graphicItem') wells++;
      return item;
    });
  } else {
    pageItems = [];
    for (const k in page.pageItems) {
      let item = page.pageItems[k];
      delete item.spellCheck;
      delete item.imageID;
      delete item.svg;

      item.text = '';
      item.styles = [];

      if (item.itemType === 'graphicItem') wells++;
      pageItems.push(item);
    }

    page = Object.values(page.pages)[0];
  }

  // the way layouts expect things is there is an pageItems for each page.. so convert this to an array and append
  // an empty element if we are 2 page.. ie. ratioBase=2
  // and for some reason it's a single element in the array..
  const pageItemArray = page.ratioBase === 2 ? [pageItems, []] : [pageItems];
  const layout = {
    numPages: Math.ceil(page.ratioBase),
    applyTo: page.pageType == 'C' ? 'W' : page.pageType,
    includeMirroredVersion: includeMirroredVersion.toString(),
    name,
    pageItems: pageItemArray,
    wells,
  };

  return layout;
}
